import { useEffect, useState } from "react";
import {
  addSmsLog,
  clearSmsLogs,
  getSmsLogs,
  rehydrateSmsLogs,
  subscribeSmsLogs,
} from "../lib/smsLogsStore";

export function useSmsLogs() {
  const [logs, setLogs] = useState(getSmsLogs());

  useEffect(() => {
    void rehydrateSmsLogs();

    const unsubscribe = subscribeSmsLogs(() => {
      setLogs(getSmsLogs());
    });

    setLogs(getSmsLogs());

    return () => {
      unsubscribe();
    };
  }, []);

  return {
    logs,
    addSmsLog,
    clearSmsLogs,
  };
}